<!--
 * @Autor: lu jun jie
 * @Date: 2020-11-18
 * @Description:
-->
<template>
    <div id="appButtom">
        <div id="wp_topbar" class="top-bar">
            <div class="top-bar-contain top-bar-position">
                <ul class="top-bar-ul">
                    <li class="iphone">本公司游戏产品仅适合18岁及以上玩家娱乐！</li>
                </ul>
                <div class="top-bar-position-right">
                    <p class="top-bar-user-info-account" v-show="isLogin">{{account}}</p>
                    <div class="top-bar-login" @click="login()">
                        {{loginText}}
                    </div>
                </div>
            </div>
        </div>
        <!-- LOGO 导航 搜索-->
        <div class="top-nav">
            <div class="top-nav-contain">
                <a href="home" target="_self" class="logo">
                    <img src="../../../../Public//Media/images/logo.png" alt="logo" />
                </a>
                <div class="search-box search-box-position" style="float: right">
                    <input type="text" id="key-words" />
                    <a href="game">
                        <input name="" type="hidden" value="" id="inputselect" placeholder="搜索游戏" />
                    </a>
                </div>
                <ul class="top-nav-ul" style="float: right">
                    <li>
                        <a target="_self" href="home">首页</a>
                    </li>
                    <li>
                        <a href="customer" target="_blank">客服</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import '../../../../Public/Media/css/2018_nav.css'
import '../../../../Public/Media/css/2018_56c5a1d31218463e.css'
import '../../../../Public/Media/css/2018index.css'
import '../../../../Public/Media/css/global.css'
import '../../../../Public/Media/css/2021_nav.css'

export default {
    name: 'appButtom',
    data() {
        return {
            iconAccount: '',
            account: '',
            loginText: '登录',
            isLogin: false,
        }
    },
    mounted() {
        if (BGHttp.getToken()) {
            this.account = BGHttp.loadUserInfo('account')
            window.store.commit('setLoginState', true)
        }
    },
    watch: {
        '$store.state.isLogin': function (flag) {
            this.isLogin = flag
            this.loginText = flag ? '退出' : '登录'
            if (flag) this.account = BGHttp.loadUserInfo('account')
        },
    },
    methods: {
        login() {
            if (this.isLogin) {
                BGHttp.clearUserInfo()
                window.store.commit('setLoginState', false)
                this.$router.push('login')
            } else {
                this.$router.push('login')
            }
        },
    },
}
</script>

<style>
.top-bar .top-bar-ul li {
    background: none;
}
</style>



// WEBPACK FOOTER //
// src/components/common/header/index.vue